import { render, staticRenderFns } from "./TheDocphantList.vue?vue&type=template&id=0e4f1ef9&scoped=true"
import script from "./TheDocphantList.vue?vue&type=script&lang=ts"
export * from "./TheDocphantList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4f1ef9",
  null
  
)

export default component.exports